export const getPropValue = (propertyParent: any, property: string, fallbackContent?: any): any => {
    if (!propertyParent.properties[property] && fallbackContent) {
        return fallbackContent;
    }
    return propertyParent.properties[property];
};